/**
 * <AutoT> — render arbitrary text run through `useAutoTranslate`.
 * Safe to use inside `.map()` since each instance owns its hook call.
 */
import { useAutoTranslate } from "./useAutoTranslate";

export function AutoT({ text }: { text: string | null | undefined }) {
  const t = useAutoTranslate(text);
  return <>{t || text || ""}</>;
}
